<app-timeline-transport-order-information [order]='this.currentOrder'></app-timeline-transport-order-information>
<app-timeline-transport-all-orders></app-timeline-transport-all-orders>
<app-timeline-add-site></app-timeline-add-site>
<div class='acceptedOrdersContainer articContractsContainer'>
  <div class='header'>
    <i class="fas fa-fw fa-truck-loading"></i> Contract Orders &nbsp;&nbsp;<button class='btn btn-secondary btn-small' (click)='this.loadOrders()'><i class="fas fa-sync-alt"></i></button>
  </div>

  <div class="bodyContainer">

    <ng-select [(ngModel)]="this.searchFilters.customer" (change)='this.searchFilters.customer = $event;'>
      @for (item of this.accounts; track item) {
        <ng-option [selected]='this.searchFilters.customer === item.id' [value]='item.id'>{{ item.name }}</ng-option>
      }
    </ng-select>

    <ng-select [(ngModel)]="this.searchFilters.site" (change)='this.searchFilters.site = $event;'>
      @for (item of this.sites; track item) {
        <ng-option [value]='item.id' [selected]='this.searchFilters.site === item.id'>{{ item.name }}</ng-option>
      }
    </ng-select>

    <ng-select [(ngModel)]="this.searchFilters.tipSite" (change)='this.searchFilters.tipSite = $event;'>
      @for (item of this.tips; track item) {
        <ng-option [selected]='this.searchFilters.tipSite === item.id' [value]='item.id'>{{ item.name }}</ng-option>
      }
    </ng-select>


    <button class='btn btn-primary' (click)='this.loadOrders()'>Search</button>
    <button class='btn btn-danger' (click)='this.clear()'>Clear</button>
    <button class='btn btn-Secondary' (click)='this.openModal("transportAllOrdersModal")'>Show Orders</button>

    <br />
    <button class='btn btn-Secondary' routerLink='/orders/new/accounts'>+ New Order</button>
    <button class='btn btn-Secondary' (click)='this.newSite()'>+ New Account/Site</button>

    <!-- <div class="form-group">
    <label for="inputPassword4">Sort by</label>
    <select class='form-control' (change)='this.sortBy = $event.target.value; this.loadOrders()'>
      <option value='time'>Time</option>
      <option value='account'>Account</option>
      <option value='po-number'>PO Number</option>
    </select>
  </div> -->

  <!-- used for clone icon don't remove-->
  <div id="div2" style='display:none;z-index:9999999999'>Test</div>

  @if (this.orders.length > 0) {
    @for (order of this.orders; track order) {
      <!-- Normal orders -->
      @if (order.shredderOrderTypeId !== 3) {
        <div
          class='orderContainer row ml-0'
          [class.changed]='order.createdBy !== order.updatedBy && order.updatedBy !== -1'
          [class.dragging]='this.draggingId == order.id'
          data-id='{{ order.id }}'
          draggable="true"
          (dragstart)='dragStart($event, order)'
          (dragend)='dragEnd($event)'>
          <div class="col-2 text-center">
            <button
              class='btn btn-secondary btn-small'
              (click)='this.currentOrder = order; openModal("orderTransportInformationModal")'
              >
              <i class="fas fa-info-circle"></i>
            </button>&nbsp;
            <button
              class='btn btn-secondary btn-small'
              (click)='this.makeOrderDaily(order)'
              >
              <i class="fas fa-calendar-day"></i>
            </button>
            <br/>
            <span
              class="badge badge-pill"
              [class.badge-secondary]='this.getAllocatedQty(order) === 0'
              [class.badge-primary]='this.getAllocatedQty(order) < this.getOrderQty(order)'
              [class.badge-success]='this.getAllocatedQty(order) === this.getOrderQty(order)'
              [class.badge-danger]='this.getAllocatedQty(order) > this.getOrderQty(order)'
            >{{this.getAllocatedQty(order)}}/{{this.getOrderQty(order)}}</span>
          </div>
          <div class="col">
            <strong>{{ order.account.name }}</strong>
            {{ order.site.name }}
            @if (order.tipSite !== null) {
              TO {{ order.tipSite.name }}
            }
            Job Type: <strong>Per {{ this.getUnitForJob(order) }}</strong>
            <br />
            @if (order.createdBy !== order.updatedBy && order.updatedBy !== -1) {
              <span>Changed By: {{ order.updatedUser.firstName }} {{ order.updatedUser.lastName }}</span><br />
            }
            @if (this.orderTypeId === 8 && order.shredderOrderTypeId === 3) {
              @if (!order.isPrepaid) {
                <span>Delivery</span>
              }
              @if (order.isPrepaid) {
                <span>Collection</span>
              }
            }
          </div>
        </div>
      }
    }
    <div class="gridPagination">
      <ul>
        @if (this.isPrevActive()) {
          <li>
            <button
              class="btn btn-secondary"
              type="button"
              name="button"
              (click)="onPaginationPageClicked(this.getCurrentPage() - 1)"
              >
              &lt;
            </button>
          </li>
        }
        @if (this.paginationService.getTotalPages() <= 30) {
          @for (page of this.getPagesArray(); track page) {
            <li>
              <button
                class="btn btn-secondary"
                type="button"
                name="button"
                (click)="onPaginationPageClicked(page)"
                [class.active]="page === this.getCurrentPage()"
                >
                {{ page }}
              </button>
            </li>
          }
        }
        @if (this.paginationService.getTotalPages() > 30) {
          @for (page of this.paginationService.getShortPagesRange(this.paginationService.getPage(), this.paginationService.getTotalPages()); track page) {
            @if (page !== "...") {
              <li>
                <button
                  class="btn btn-secondary"
                  type="button"
                  name="button"
                  (click)="onPaginationPageClicked(page)"
                  [class.active]="page === this.getCurrentPage()"
                  >
                  {{ page }}
                </button>
              </li>
            }
            @if (page === "...") {
              <span>...</span>
            }
          }
        }
        @if (this.isNextActive()) {
          <li>
            <button
              class="btn btn-secondary"
              type="button"
              name="button"
              (click)="onPaginationPageClicked(this.getCurrentPage() + 1)"
              >
              &gt;
            </button>
          </li>
        }
      </ul>
    </div>
  }
  @if (this.orders.length === 0) {
    <div style='color:red;font-weight:bold'>No results found</div>
  }
</div>
</div>
